/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import LoadPanel from "devextreme-react/load-panel";
import DataGrid, {
  Column,
  Paging,
  Selection,
  FilterRow,
} from "devextreme-react/data-grid";
import { useDispatch, useSelector } from "react-redux";
import { formatMessage } from "devextreme/localization";

import notify from "devextreme/ui/notify";
import { ScrollView } from "devextreme-react/scroll-view";
import {
  showRoleUser,
  showRole,
  showUser,
  IsPermisionOidRequired,
} from "../../../../redux/actions";
import {
  responseRole,
  responseRoleUser,
  responseUser,
  responseMiddleware,
} from "../../../../redux/reducers";

import RoleUserTableList from "./RoleUserTable";
import UsingIntl from "../../../../services/using_intl";
import PopupConfig from "../../../../common/popup";
// import "../style.scss";

export default function RoleUserPage() {
  const [selectedItemKeys, setSelectedItemKeys] = useState([]);
  const [selectedItemKeysPopup, setSelectedItemKeysPopup] = useState([]);
  const [selectedBox, setSelectedBox] = useState("");

  const dispatch = useDispatch();
  let dataGrid = useRef(null);
  const history = useHistory();

  const { role } = useSelector(responseRole);
  const { user } = useSelector(responseUser);
  const { roleUser } = useSelector(responseRoleUser);
  const { middleware, loading } = useSelector(responseMiddleware);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();

  useEffect(() => {
    dispatch(IsPermisionOidRequired());
    UsingIntl();
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
      dispatch(showRole());
      dispatch(showRoleUser());
      dispatch(showUser());
    }
  }, [middleware]);

  const handleChangeSelectBox = ({ value }) => {
    setSelectedBox(value._value);
    dispatch(showRoleUser(value._value));
  };
  const selectionPopupChanged = ({ selectedRowsData }) => {
    setSelectedItemKeysPopup(selectedRowsData);
  };
  const handleSubmitPopup = async () => {
    if (!selectedItemKeysPopup.length) {
      notify("vui lòng nhập dữ liệu", "warning", 2000);
    }

    try {
      for (const key in selectedItemKeysPopup) {
        const data = {
          Role: { Oid: selectedBox },
          User: { Oid: selectedItemKeysPopup[key].Oid },
        };
        roleUser.store().insert(data);
      }
      handleClosePopup();
      dataGrid.current.instance.refresh();
    } catch (error) {
      notify("something went wrong", "error", 2000);
    }
  };

  const deleteRecords = () => {
    selectedItemKeys.forEach((key) => {
      roleUser.store().remove(key);
    });
    setSelectedItemKeys({
      selectedItemKeys: [],
    });
    roleUser.reload();
  };

  const renderPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={formatMessage("AddNewUser")}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <ScrollView width="100%" height="100%">
          <DataGrid
            id="gridContainer2"
            dataSource={user}
            keyExpr="Oid"
            showBorders={true}
            // selectedRowKeys={selectedItemKeysPopup}
            onSelectionChanged={selectionPopupChanged}
          >
            <FilterRow visible={true} />
            <Paging enabled={true} />
            <Selection
              mode="multiple"
              selectAllMode="page"
              showCheckBoxesMode="always"
            />
            <Column dataField="UserName" caption={formatMessage("Username")} />
            <Column
              dataField="Employee.FullName"
              caption={formatMessage("FullName")}
            />
            <Column
              dataField="Employee.Department.DepartmentName"
              caption={formatMessage("Department")}
              allowEditing={false}
            />
            <Column
              dataField="Employee.Position.PositionName"
              caption={formatMessage("Position")}
              allowEditing={false}
            />
          </DataGrid>
        </ScrollView>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          // disabled={selectedItemKeysPopup[0].Oid ? true : false}
          location="after"
          onClick={handleSubmitPopup}
          options={{
            icon: "save",
            type: "default",
            text: formatMessage("Save"),
            width: "200px",
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };
  const selectionChanged = ({ selectedRowKeys }) => {
    setSelectedItemKeys(selectedRowKeys);
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("Role User")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/permissions" className={"breadcrumb-item"}>
            {formatMessage("Permission")}
          </Link>
          <Link to="/permissions/roles" className={"breadcrumb-item"}>
            {formatMessage("Role")}
          </Link>

          <span className={"breadcrumb-item active"}>
            {formatMessage("Role User")}
          </span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderPopup()}
          <RoleUserTableList
            roleUser={roleUser}
            dataGrid={dataGrid}
            role={role}
            selectedItemKeys={selectedItemKeys}
            selectionChanged={selectionChanged}
            handleOpenPopup={handleOpenPopup}
            selectedBox={selectedBox}
            handleChangeSelectBox={handleChangeSelectBox}
            deleteRecords={deleteRecords}
            middleware={middleware}
          />
        </div>
      </div>
    </div>
  );
}
